import * as React from 'react';
import DividerMUI, { DividerProps as DividerMUIProps } from '@material-ui/core/Divider';
import { makeStyles, createStyles } from '@material-ui/core/styles';


type DividerProps = {
	margin?: 'small';
} & DividerMUIProps

const useStyles = makeStyles<any, DividerProps, any>(() =>
  createStyles({
    root: ({ margin }) => ({
			marginTop: margin === 'small' ? 8 : 0,
			marginBottom: margin === 'small' ? 8 : 0,
    }),
  }),
);

const Divider: React.SFC<DividerProps> = (props) => {
	const { margin, className = '', ...rest } = props;
	const classess = useStyles(props);

	return (
		<DividerMUI {...rest} className={`${classess.root} ${className}`} />
	);
}

Divider.displayName = 'Divider';
Divider.defaultProps = {};

export default Divider;
